import React, { useState, useRef, useEffect } from 'react';
import { User, Settings, Shield, HelpCircle, LogOut, MoreVertical, Menu } from 'lucide-react';

const ProfileMenu = ({ 
  isDarkMode, 
  onNavigate, 
  onLogout, 
  showProfileMenu, 
  setShowProfileMenu,
  user
}) => {
  const menuRef = useRef(null);

  // Menü dışına tıklandığında kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setShowProfileMenu]);

  if (!showProfileMenu) return null;

  return (
    <div 
      ref={menuRef}
      className={`absolute right-4 top-16 w-64 rounded-xl shadow-lg 
        ${isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}
        transition-all duration-200 ease-in-out transform origin-top-right
        ${showProfileMenu ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}
    >
      {/* Kullanıcı Bilgisi */}
      <div className={`p-4 flex items-center space-x-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isDarkMode ? 'bg-indigo-900' : 'bg-blue-100'}`}>
          <User size={20} className={isDarkMode ? 'text-indigo-300' : 'text-blue-600'} />
        </div>
        <div>
          <p className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            {user?.name || 'Kullanıcı'}
          </p>
          <p className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-500'}`}>
            {user?.username || '@kullanici'}
          </p>
        </div>
      </div>

      {/* Menü Öğeleri */}
      <div className={`py-2 ${isDarkMode ? 'divide-gray-700' : 'divide-gray-200'} divide-y`}>
        <button
          onClick={() => {
            setShowProfileMenu(false);
            onNavigate('profileEdit');
          }}
          className={`w-full flex items-center space-x-3 p-3 transition-colors
            ${isDarkMode ? 'hover:bg-gray-700 text-gray-200' : 'hover:bg-gray-50 text-gray-700'}`}
        >
          <User size={18} />
          <span>Profili Düzenle</span>
        </button>

        <button
          onClick={() => {
            setShowProfileMenu(false);
            onNavigate('settings');
          }}
          className={`w-full flex items-center space-x-3 p-3 transition-colors
            ${isDarkMode ? 'hover:bg-gray-700 text-gray-200' : 'hover:bg-gray-50 text-gray-700'}`}
        >
          <Settings size={18} />
          <span>Ayarlar</span>
        </button>

        <button
          onClick={() => {
            setShowProfileMenu(false);
            onNavigate('security');
          }}
          className={`w-full flex items-center space-x-3 p-3 transition-colors
            ${isDarkMode ? 'hover:bg-gray-700 text-gray-200' : 'hover:bg-gray-50 text-gray-700'}`}
        >
          <Shield size={18} />
          <span>Güvenlik</span>
        </button>

        <button
          onClick={() => {
            setShowProfileMenu(false);
            onNavigate('help');
          }}
          className={`w-full flex items-center space-x-3 p-3 transition-colors
            ${isDarkMode ? 'hover:bg-gray-700 text-gray-200' : 'hover:bg-gray-50 text-gray-700'}`}
        >
          <HelpCircle size={18} />
          <span>Yardım ve Destek</span>
        </button>

        <button
          onClick={() => {
            setShowProfileMenu(false);
            onLogout();
          }}
          className={`w-full flex items-center space-x-3 p-3 transition-colors
            ${isDarkMode ? 'hover:bg-red-900/30 text-red-400' : 'hover:bg-red-50 text-red-600'}`}
        >
          <LogOut size={18} />
          <span>Çıkış Yap</span>
        </button>
      </div>
    </div>
  );
};

export default ProfileMenu;
